import script from "./LiveSessionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveSessionView.vue?vue&type=script&setup=true&lang=ts"

import "./LiveSessionView.vue?vue&type=style&index=0&id=2648d4c5&lang=css"

const __exports__ = script;

export default __exports__